'use client';
import parse from 'html-react-parser';
import Link from 'next/link';
import { Button, SvgImage } from '@overlapdev/elements';
import Image from 'next/image';
import { PageType, TaxonomyTermType } from '@overlapdev/types';
import { CircleArrowSVG, JuliasLogoSVG } from 'components/svg';

const LocationMapPopup = ({ item }: { item: PageType }) => {
	//__Variables
	const { acf, post_title, relative_path } = item || {};
	const { baths, beds, community_status, development_phase, grid_image, home_status } = acf || {};

	//__Functions

	//__Use Effect

	return (
		<div className='flex flex-col group overflow-hidden relative rounded-3xl transition-ease shadow-[30px_35px_55px_0px_rgba(46,46,46,0.23)] w-[250px] lg:w-[320px]'>
			<div className='overflow-hidden relative h-[120px] md:h-[180px]'>
				{grid_image?.url ? (
					<Image src={grid_image.url} alt={grid_image.alt} fill className='object-cover object-[50%_50%] transition-ease md:group-hover:scale-110' sizes='960px' />
				) : (
					<div className='bg-black/10 flex h-full items-center justify-center p-4 lg:p-10'>
						<JuliasLogoSVG className='opacity-60' fill='#fff' />
					</div>
				)}
			</div>
			<div className='bg-white flex flex-col gap-2 grow items-start px-6 py-4 rounded-b-3xl'>
				{community_status ? (
					<div className='border-2 flex font-semibold gap-1 items-center px-4 py-1 rounded-full text-black' style={{ borderColor: community_status?.acf?.color || '#000' }}>
						{community_status?.acf?.icon_image ? <SvgImage className='block text-grey w-4' image={community_status?.acf?.icon_image} /> : null}
						{community_status.name}
					</div>
				) : null}
				{development_phase ? (
					<div className='border-2 flex font-semibold gap-1 items-center px-3 py-1 rounded-full text-black' style={{ borderColor: development_phase?.acf?.color || '#000' }}>
						{development_phase?.acf?.icon_image ? <SvgImage className='block text-grey w-4' image={development_phase?.acf?.icon_image} /> : null}
						{development_phase.name}
					</div>
				) : null}
				{home_status ? (
					<div className='border-2 flex font-semibold gap-1 items-center px-3 py-1 rounded-full text-black' style={{ borderColor: home_status?.acf?.color || '#000' }}>
						{home_status?.acf?.icon_image ? <SvgImage className='block text-grey w-4' image={home_status?.acf?.icon_image} /> : null}
						{home_status.name}
					</div>
				) : null}
				<div className='font-semibold text-black text-lg'>{parse(post_title)}</div>
				{beds || baths ? (
					<div className='flex flex-wrap font-semibold gap-1'>
						{beds ? <div className='bg-grey px-3 rounded-full text-white'>{beds?.length ? beds.map((e: TaxonomyTermType) => e.name).join(', ') : beds.name} Beds</div> : null}
						{baths ? <div className='bg-grey px-3 rounded-full text-white'>{baths?.length ? baths.map((e: TaxonomyTermType) => e.name).join(', ') : baths.name} Baths</div> : null}
					</div>
				) : null}
				<div className=''>
					<Button link={{ url: relative_path, title: 'See Details' }} className='arrow_link group_hover'>
						<CircleArrowSVG width={18} />
					</Button>
				</div>
			</div>
			{relative_path ? (
				<Link href={relative_path} className='absolute h-full left-0 top-0 w-full'>
					<span className='hidden'>{post_title}</span>
				</Link>
			) : null}
		</div>
	);
};

export default LocationMapPopup;
